import React from 'react';
import { Link } from 'react-router-dom';
import { TOOL_TYPES } from '../../store/useToolStore';
import { TOOL_SLUGS } from '../../data/toolSlugs';

const TOOL_NAMES = {
  [TOOL_TYPES.LOADER]: 'Loader Generator',
  [TOOL_TYPES.GRADIENT]: 'Gradient Generator',
  [TOOL_TYPES.CARD]: 'Card Generator',
  [TOOL_TYPES.ANIMATION]: 'Animation Generator',
  [TOOL_TYPES.ALERT]: 'Alert Generator',
  [TOOL_TYPES.PHOTO_PICKER]: 'Photo Picker Generator',
  [TOOL_TYPES.SHADOW]: 'Shadow Generator',
  [TOOL_TYPES.BUTTON]: 'Button Builder',
  [TOOL_TYPES.GRID]: 'Grid Generator',
  [TOOL_TYPES.PALETTE]: 'Color Palette Generator',
  [TOOL_TYPES.JSON_TO_MODEL]: 'JSON to Codable Generator',
  [TOOL_TYPES.API_GENERATOR]: 'API Generator',
  [TOOL_TYPES.STORYBOARD_CONVERTER]: 'Storyboard Converter',
  [TOOL_TYPES.POSTMAN_IMPORTER]: 'Postman Importer',
};

const Footer = () => {
  const navTools = TOOL_SLUGS.filter((t) => t.toolType !== TOOL_TYPES.STORYBOARD_CONVERTER);

  return (
    <footer className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 transition-colors duration-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Brand Section */}
          <div className="col-span-1">
            <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">SwiftToolsKit</h3>
            <p className="text-gray-600 dark:text-gray-400 text-xs mb-3">
              Free Swift and SwiftUI code generator tools for iOS developers.
            </p>
            <div className="flex space-x-3">
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-500 transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                </svg>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-500 transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Tools Section */}
          <div>
            <h4 className="text-xs font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-3">Tools</h4>
            <ul className="space-y-1.5">
              {navTools.map((t) => (
                <li key={t.toolType}>
                  <Link to={t.seoPath} className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-500 text-xs transition-colors">
                    {TOOL_NAMES[t.toolType] || t.toolType}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter & Contact */}
          {/* Temporarily commented out */}
          {/* <div>
            <h4 className="text-xs font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-3">Stay Updated</h4>
            <p className="text-gray-600 dark:text-gray-400 text-xs mb-3">
              Get updates on new tools.
            </p>
            <form className="space-y-2">
              <input
                type="email"
                placeholder="Your email"
                className="w-full px-3 py-1.5 bg-gray-50 dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg text-gray-900 dark:text-white text-xs focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
              <button
                type="submit"
                className="w-full px-3 py-1.5 bg-gradient-primary bg-gradient-primary-hover rounded-lg text-white text-xs font-medium transition-colors"
              >
                Subscribe
              </button>
            </form>
            <div className="mt-3">
              <p className="text-gray-600 dark:text-gray-400 text-xs">
                <a href="mailto:contact@swifttoolkit.com" className="text-primary-600 dark:text-primary-500 hover:underline">contact@swifttoolkit.com</a>
              </p>
            </div>
          </div> */}
        </div>

        {/* Bottom Bar */}
        <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-600 dark:text-gray-400 text-xs">
              © {new Date().getFullYear()} SwiftToolsKit. All rights reserved.
            </p>
            <div className="flex flex-wrap gap-4 mt-2 md:mt-0">
              <Link to="/about" className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-500 text-xs transition-colors">
                About Us
              </Link>
              <Link to="/contact" className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-500 text-xs transition-colors">
                Contact Us
              </Link>
              <Link to="/privacy" className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-500 text-xs transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-500 text-xs transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

